import { render, staticRenderFns } from "./NumberReadOnly.vue?vue&type=template&id=2cf98c11&"
import script from "./NumberReadOnly.vue?vue&type=script&lang=js&"
export * from "./NumberReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf98c11')) {
      api.createRecord('2cf98c11', component.options)
    } else {
      api.reload('2cf98c11', component.options)
    }
    module.hot.accept("./NumberReadOnly.vue?vue&type=template&id=2cf98c11&", function () {
      api.rerender('2cf98c11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/number/NumberReadOnly.vue"
export default component.exports